// extracted by mini-css-extract-plugin
export var banner = "_t0-0";
export var settingRow = "_t0-2";
export var titleIcon = "_t0-1";